import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

import { CoreRoutingModule } from '@core/core-routing.module';
import { CoreComponent } from '@core/core.component';
import { SidebarComponent } from '@core/_components/sidebar/sidebar.component';
import { HeaderComponent } from '@core/_components/header/header.component';
import {SharedModule} from '@modules/shared/shared.module';
import {TranslocoRootModule} from '@app/transloco-root.module';
import { FooterComponent } from './_components/footer/footer.component';



@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    SharedModule,
    CoreRoutingModule,
    NgbDropdownModule,
    TranslocoRootModule
  ],
  declarations: [CoreComponent, SidebarComponent, HeaderComponent, FooterComponent]
})
export class CoreModule { }
